export default {
  name: 'ConfirmTemplate',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Sim'
    },
    cancelText: {
      type: String,
      default: 'Não'
    },
    confirmColor: {
      type: String,
      default: 'marca-0-l10'
    },
    cancelColor: {
      type: String,
      default: undefined
    },
    hideCancel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      open: false
    };
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
};